import React from 'react';
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import axios from "../axios";
import { Apps } from "../api/api";

import Dashboard from "../Dashboard";

import {
  Button,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

export default function AppUpdate() {
  const { id } = useParams<{
    id: string;
  }>();
  const navigation = useNavigate();
  const [app, setApp] = useState<Apps>({});

  useEffect(() => {
    axios.get("/apps/" + id).then((res) => {
      setApp(res.data);
    });
  }, [id]);

  const handleUpdate = () => {
    axios.put("/apps/" + id, app).then((_res) => {
      navigation("/apps/" + id);
    });
  };

  const handleChangeServiceId = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setApp({ ...app, service_id: event.target.value });
  };

  const handleChangeAppId = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setApp({ ...app, app_id: event.target.value });
  };

  const handleChangeAppName = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setApp({ ...app, app_name: event.target.value });
  };

  const handleChangeAppVersion = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setApp({ ...app, app_version: event.target.value });
  };

  const handleChangeMemo = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setApp({ ...app, memo: event.target.value });
  };

  return (
    <Dashboard title="アプリ管理">
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="サービスID"
                variant="outlined"
                required
                fullWidth
                value={app.service_id}
                onChange={handleChangeServiceId}
                InputLabelProps={{ shrink: true }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="アプリID"
                variant="outlined"
                required
                fullWidth
                value={app.app_id}
                onChange={handleChangeAppId}
                InputLabelProps={{ shrink: true }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="アプリ名"
                variant="outlined"
                required
                fullWidth
                value={app.app_name}
                onChange={handleChangeAppName}
                InputLabelProps={{ shrink: true }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="アプリバージョン"
                variant="outlined"
                required
                fullWidth
                value={app.app_version}
                onChange={handleChangeAppVersion}
                InputLabelProps={{ shrink: true }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="備考"
                variant="outlined"
                required
                multiline
                fullWidth
                value={app.memo}
                onChange={handleChangeMemo}
                InputLabelProps={{ shrink: true }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br />
      <Grid item xs={12}>
        <Button color="primary" variant="contained" onClick={handleUpdate} sx={{ m: 1 }}>
          Update
        </Button>
      </Grid>
    </Dashboard>
  );
}
